module.exports = __webpack_public_path__ + "static/img/illu_de_02.6da80a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_de_02.png
// module id = Fw/j
// module chunks = 1